export default{
    InvoicTitle:{
        Headers:{
            title:"您已经添加了",
            title1:"个发票信息，还可以添加",
            title2:"个",
        },
        form:{
            query:"订单号",
            invoApplyStatus:"发票状态",
            datepicker:"申请时间",
            defaultFlag:"默认抬头",
            defaultFlag1:"设为默认",
        },
        placeholder:{
            query:"请输入订单编号",
            invoApplyStatus:"全部",
            datepicker:["开始时间","结束时间"],
        },
        Message:{
               type:"提示",
               content:"是否删除该条发票信息",
               success:"删除发票信息成功！",
               success1:"设置成功！",
               info:"已取消",
               warning:"无法添加发票信息，请删除列表发票信息后重新添加"
        },
        Alert:{

        },
        Button:{
            addInvo:'新增发票',
            btnRevise:"修改",
            btnDelete:"删除",
            confirmButtonText:"确定",
            cancelButtonText: "取消",
        },
        Placeholder:{

        },
        Validate:{

        },

        Description:{
            noData:'暂无发票',
            emptyText:"暂无数据"
        },
        Table:{
            headerName:['发票抬头','类型','发票内容','发票类型','社会统一信用代码','收货人姓名','联系电话','收件地址','操作'],
        }
    }
    
}